/**
 * 로그인 후 localStorage에 저장되는 키들 (AuthContext.login 과 동일)
 */

export const AUTH_LS_KEYS = Object.freeze({
  USER_ID: 'userId',
  NAME: 'name',
  COMP_CODE: 'compCode',
  COMP_NAME: 'compName',
  ROLE_ID: 'roleId',
  USER_ROLE: 'userRole',
  JWT: 'jwt',
  IS_AUTHENTICATED: 'isAuthenticated',
});

const EMPTY = {
  userId: '',
  name: '',
  compCode: '',
  compName: '',
  roleId: '',
  userRole: '',
  jwt: null,
  isAuthenticatedFlag: false,
};

export function readAuthSnapshot() {
  if (typeof window === 'undefined') {
    return { ...EMPTY };
  }
  return {
    userId: localStorage.getItem(AUTH_LS_KEYS.USER_ID)?.trim() || '',
    name: localStorage.getItem(AUTH_LS_KEYS.NAME)?.trim() || '',
    compCode: localStorage.getItem(AUTH_LS_KEYS.COMP_CODE)?.trim() || '',
    compName: localStorage.getItem(AUTH_LS_KEYS.COMP_NAME)?.trim() || '',
    roleId: localStorage.getItem(AUTH_LS_KEYS.ROLE_ID)?.trim() || '',
    userRole: localStorage.getItem(AUTH_LS_KEYS.USER_ROLE)?.trim() || '',
    jwt: localStorage.getItem(AUTH_LS_KEYS.JWT),
    isAuthenticatedFlag: localStorage.getItem(AUTH_LS_KEYS.IS_AUTHENTICATED) === 'true',
  };
}

export function isSessionPresent() {
  const s = readAuthSnapshot();
  return s.isAuthenticatedFlag && !!s.jwt;
}

export function getStoredUserId() {
  return readAuthSnapshot().userId;
}

export function readLocalMember() {
  const s = readAuthSnapshot();
  return {
    userId: s.userId,
    name: s.name,
    compCode: s.compCode,
    compName: s.compName,
  };
}

/** AI 질의현황(AppSidebar 등) — { id, name, role, company, companyName } */
export function readCurrentUserForAi() {
  const s = readAuthSnapshot();
  return {
    id: s.userId,
    name: s.name || (s.userId ? s.userId : '사용자'),
    role: s.roleId || s.userRole || '',
    company: s.compCode,
    companyName: s.compName,
  };
}
